@if ((weatherService.observation$ | async); as observation;) {
  <button mat-icon-button color="primary"
    aria-label="Wind & Wetter" routerLink="/wetter">
    <i class="wi {{(weatherService.metar$ | async) | weatherDescriptionIconName:observation}} weather-icon">
    </i>
  </button>
}